export default {"src":"/_next/static/media/marker.063eb380.svg","height":55,"width":39,"blurWidth":0,"blurHeight":0};